export default "__VITE_ASSET__D8Kxa21X__"